import React from 'react';
import { ContentCopy, CheckCircle } from '@mui/icons-material';

const EndpointCard = ({ method, path, description }) => {
    const [copied, setCopied] = React.useState(false);

    const getMethodColor = (method) => {
        const colors = {
            GET: 'bg-emerald-500/10 text-emerald-900 border-emerald-500/25 dark:bg-emerald-500/10 dark:text-emerald-200 dark:border-emerald-400/25',
            POST: 'bg-blue-500/10 text-blue-900 border-blue-500/25 dark:bg-blue-500/10 dark:text-blue-200 dark:border-blue-400/25',
            PUT: 'bg-amber-500/10 text-amber-900 border-amber-500/25 dark:bg-amber-500/10 dark:text-amber-200 dark:border-amber-400/25',
            DELETE: 'bg-rose-500/10 text-rose-900 border-rose-500/25 dark:bg-rose-500/10 dark:text-rose-200 dark:border-rose-400/25'
        };
        return colors[method] || 'bg-slate-500/10 text-slate-800 border-slate-500/20 dark:bg-slate-500/10 dark:text-slate-200 dark:border-slate-400/20';
    };

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(path);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch {
            // ignore
        }
    };

    return (
        <div className="rounded-2xl border border-slate-200/90 bg-white p-4 shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-px dark:border-slate-700/70 dark:bg-slate-900/40">
            <div className="flex flex-col gap-3">
                <div className="flex items-start gap-3">
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border ${getMethodColor(method)}`}>
                        {method}
                    </span>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                            <code className="flex-1 min-w-0 text-[13px] sm:text-sm font-mono text-slate-900 dark:text-slate-100 bg-slate-50/80 dark:bg-slate-950/40 px-3 py-2 rounded-xl border border-slate-200/80 dark:border-slate-700/70 overflow-x-auto">
                                {path}
                            </code>
                            <button
                                type="button"
                                onClick={copy}
                                className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300/60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
                                aria-label="Copier l'endpoint"
                                title="Copier l'endpoint"
                            >
                                {copied ? <CheckCircle className="text-emerald-500" fontSize="small" /> : <ContentCopy fontSize="small" />}
                                <span className="text-xs font-semibold">{copied ? 'Copié' : 'Copier'}</span>
                            </button>
                        </div>
                        {description ? (
                            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
                                {description}
                            </p>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EndpointCard;